import { Injectable } from '@angular/core';
import { HttpHandlerService } from '@shared/services/http-handler.service';
import { environment } from '@env';
import { Accounting } from '@shared/models/Accounting';
import { GenericResponse } from '@shared/models/GenericResponse';
import { KeyMap } from '@shared/models/KeyMap';
import { Organization } from '@shared/models/Organization';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ArrayUtils } from '@shared/utils/array.utils';

const BASE_URL = `${environment.serviceUrl}/api/v1/contabilidades`;

@Injectable({ providedIn: 'root' })
export class AccountingService {

  constructor(private http: HttpHandlerService) {}

  public patch(id: number, body: KeyMap<Organization>, isOauthId = false) {
    if (!isOauthId) {
      const url = `${BASE_URL}/${id}`;
      return this.http.patch(url, body, 'Falha ao atualizar contabilidade!');
    }
    return this.fetchByOauthId(id)
    .pipe(switchMap(response => this.patch(response.record.id, body)));
  }

  public fetchByOauthId(oauthId: number) {
    const url = `${BASE_URL}/${oauthId}/oauth`;
    return this.http.get<GenericResponse<Accounting>>(url, 'Falha ao obter informações da contabilidade!');
  }

  public updateAccounting(accounting: Accounting) {
    const isEmpty = !accounting.classificacao ||
                    !accounting.perfil ||
                    !accounting.chaveDeAcesso ||
                    !accounting.sistemaContabil ||
                    accounting.chatBloqueado === undefined ||
                    accounting.chatBloqueado == null;

    if (isEmpty) {
      const url = `${BASE_URL}/${accounting.cnpj}/atualizar`;
      return this.http.post<GenericResponse<Accounting>>(url, {}, '');
    }
    return of({ record: accounting });
  }

}